import { get_axios_instance, api_variables } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_VOLUNTARY_PF_HISTORY);

const _pk_name = "id";

const state = {
  data:[],
  voluntaryPfEmployeeHistory: {},
  isFetching: false,
  isSaving: false,
  isDeleting: false
};

const mutations = {
  set: (state, payload) => {
    state.data = payload;
    //console.log('fetched data', state.data)
  },

  setVoluntaryPfEmployeeHistory: (state, payload) => {
    if(payload) {
      state.voluntaryPfEmployeeHistory = payload;
    }
    //console.log('fetched voluntaryPfEmployeeHistory', state.voluntaryPfEmployeeHistory)
  },

  setFetching: (state, payload) => {
    state.isFetching = payload;
  },

  setSaving: (state, payload) => {
    state.isSaving = payload;
  },

  setDeleting: (state, payload) => {
    state.isDeleting = payload;
  },
}

const actions = {

async fetchVoluntaryPfEmployeesHistory({commit}, payload) {
  //console.log("[state/organisation/utility/setVoluntaryPfEmployeeHistory/fetchVoluntaryPfEmployees] Calling API...");
  //console.log('payload paygroup id', payload)
try {
  commit("setFetching", true);
  let res = await axios_instance.get(`/`, {
      params: {
          empId: payload
      }
  });
  commit("setFetching", false);
  //console.log("[state/organisation/utility/setVoluntaryPfEmployeeHistory/fetchVoluntaryPfEmployees] res: ", res);
  if(res.status == 200) {
    commit("setVoluntaryPfEmployeeHistory", res.data.rows);
  }
  return res;
}catch {

}
},
}

export default {
  namespaced: true,
  state, mutations, actions
}
